// =============

import React, { useState, useEffect } from 'react';
import DatePicker from 'react-multi-date-picker';
import TimePicker from 'react-multi-date-picker/plugins/time_picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import gregorian from 'react-date-object/calendars/gregorian';
import gregorian_en from 'react-date-object/locales/gregorian_en';
import DateObject from 'react-date-object';
import moment from 'moment-timezone';
import styles from './styles.module.css';
import { useLocale } from 'next-intl';
import persian_en from 'react-date-object/locales/persian_en';
import ToolbarIcons from '@/icons/toolbar';

// import DatePicker, { DateObject } from 'react-multi-date-picker'; // Imported DateObject here

interface ShamsiDateTimePickerProps {
  initialMiladi?: string; // "YYYY-MM-DD HH:mm" from API (Tehran time)
  onChange?: (miladiDateTime: string) => void;
  title?: string;
  className?: string;
  disabled?: boolean;
  showTimePicker?: boolean;
  selectedHour?: string;
  disabledWeekDays?: number[];
  error?: string;
  showError?: boolean;
  disablePastDates?: boolean;
}

interface TimeValue {
  hour: number;
  minute: number;
}

export default function ShamsiDateTimePicker({
  initialMiladi,
  onChange,
  title = '',
  className = '',
  disabled = false,
  showTimePicker = false,
  selectedHour = '00:00',
  disabledWeekDays = [],
  error,
  showError = false,
  disablePastDates = true,
}: ShamsiDateTimePickerProps) {
  const [dateValue, setDateValue] = useState<DateObject | null>(null);
  const [timeValue, setTimeValue] = useState<TimeValue>({
    hour: Number(selectedHour?.split(':')?.[0]),
    minute: Number(selectedHour?.split(':')?.[1]),
  });
  const locale = useLocale();
  console.log('selectedHour==', selectedHour);
  useEffect(() => {
    // setTimeValue({ hour: Number(selectedHour?.split(":")?.[0]), minute: Number(selectedHour?.split(":")?.[1]) })
    handleTimeChange({
      hour: Number(selectedHour?.split(':')?.[0]),
      minute: Number(selectedHour?.split(':')?.[1]),
    });
  }, [selectedHour]);
  // useEffect(()=>{
  //   getTimePickerValue()
  // },[timeValue])

  // API → UI: Miladi → Shamsi + time
  useEffect(() => {
    if (!initialMiladi) {
      handleDateChange(null);
      setTimeValue({ hour: '00', minute: '00' });
      onChange(null);
      // return
    } else {
      const m = moment.tz(initialMiladi, 'YYYY-MM-DD HH:mm', 'Asia/Tehran');

      const shamsiDate = new DateObject({
        date: m.format('YYYY-MM-DD'),
        calendar: gregorian,
        locale: gregorian_en,
      }).convert(persian, persian_fa);

      setDateValue(shamsiDate);
      setTimeValue({ hour: m.hour(), minute: m.minute() });
    }
  }, [initialMiladi]);

  // UI → API: Shamsi + time → Miladi (Tehran)
  const emitChange = (date: DateObject | null, time: TimeValue) => {
    if (!date || !time) return;

    const miladiDate = date.convert(gregorian, gregorian_en).format('YYYY-MM-DD');

    const tehranDateTime = moment.tz(
      `${miladiDate} ${time.hour}:${time.minute}`,
      'YYYY-MM-DD H:m',
      'Asia/Tehran',
    );

    onChange?.(tehranDateTime.format('YYYY-MM-DD HH:mm'));
  };

  // const handleDateChange = (val: DateObject | null) => {
  //   setDateValue(val);
  //   emitChange(val, timeValue);
  // };

  const handleDateChange = (val: DateObject | null | string) => {
    if (!val) {
      setDateValue(null);
      onChange?.('');
      return;
    }

    setDateValue(val as DateObject);
    emitChange(val as DateObject, timeValue);
  };

  const handleTimeChange = (val: DateObject) => {
    const t: TimeValue = { hour: val.hour, minute: val.minute };
    setTimeValue(t);
    emitChange(dateValue, t);
  };

  // Create a DateObject for time picker that includes hour/minute
  const getTimePickerValue = (): DateObject | null => {
    if (!dateValue) return null;
    return new DateObject({
      year: dateValue.year,
      month: dateValue.month,
      day: dateValue.day,
      hour: timeValue.hour,
      minute: timeValue.minute,
      calendar: persian,
      locale: persian_fa,
    });
  };
  const todayShamsi = new DateObject({
    date: moment.tz('Asia/Tehran').format('YYYY-MM-DD'),
    calendar: gregorian,
    locale: gregorian_en,
  }).convert(persian, persian_fa);

  return (
    <div className={`inputPart ${styles.container} ${styles.dateContainer} ${className}`}>
      {/* {title && <label className={`${styles.formTitle}`}>{title}</label>} */}

      {/* -------- Shamsi Date -------- */}
      <div className={` ${'rmdp-input_wrapper '} `}>
        <DatePicker
          value={dateValue}
          // onChange={handleDateChange}
          onChange={(value) => {
            if (value === '') {
              handleDateChange(null);
            } else {
              handleDateChange(value as DateObject);
            }
          }}
          calendar={locale == 'fa' ? persian : gregorian}
          locale={locale == 'fa' ? persian_fa : gregorian_en}
          format="YYYY/MM/DD"
          calendarPosition={locale === 'fa' ? 'bottom-left' : 'bottom-right'}
          // mapDays={({ date }) => {
          //   const d = date.weekDay.index;
          //   if (d === 0) return { disabled: true };
          // }}
          mapDays={({ date }) => {
            if (disabledWeekDays?.includes(date.weekDay.index)) {
              return { disabled: true };
            }
          }}
          style={{ width: '100%' }}
          disabled={disabled}
          className={`${styles.input}`}
          onOpenPickNewDate={false}
          // minDate={todayShamsi}
          minDate={disablePastDates ? todayShamsi : undefined}

          placeholder={title}
          editable={!disabled} // Allow editing only if not disabled
        />
        <ToolbarIcons.DownIcon className={`${styles.downIcon}`} />
      </div>
      {showError && error && (
        <p className="inputErrorText" style={{ color: 'red', marginTop: '4px' }}>
          {error}
        </p>
      )}
      {/* -------- Time Picker (Tehran) -------- */}
      {showTimePicker && (
        <div style={{ marginTop: '8px', position: 'relative' }}>
          <DatePicker
            value={getTimePickerValue()}
            onChange={handleTimeChange}
            disableDayPicker
            format="HH:mm"
            plugins={[<TimePicker hideSeconds position="bottom" />]}
            style={{ width: '100%' }}
            disabled={disabled}
            editable={!disabled} // Allow editing only if not disabled
          />
        </div>
      )}
    </div>
  );
}
